import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center p-15 p-sm-20 p-md-25" }
const _hoisted_5 = {
  class: "d-sm-flex align-items-center",
  style: {"width":"100%"}
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "form-group mb-15 mt-30 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "col-4" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = {
  key: 0,
  class: "col-4"
}
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "col-4" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "offset-10 col-3" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_21 = { class: "table-responsive" }
const _hoisted_22 = {
  class: "table text-nowrap align-middle mb-0",
  id: "my-table"
}
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_33 = {
  key: 0,
  class: "badge text-outline-info"
}
const _hoisted_34 = {
  key: 1,
  class: "badge text-outline-success"
}
const _hoisted_35 = {
  key: 2,
  class: "badge text-outline-danger"
}
const _hoisted_36 = {
  key: 3,
  class: "badge text-outline-danger"
}
const _hoisted_37 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              style: {"width":"100%"},
              class: "search-box position-relative me-15"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_Field, {
                        name: "recherche",
                        type: "text",
                        modelValue: $setup.recherche,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.recherche) = $event)),
                        class: "form-control shadow-none text-black rounded-0 border-0",
                        placeholder: "Rechercher"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "recherche",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Modèle de boîte"),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "modeleBoite",
                        modelValue: $setup.model,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.model) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: $setup.modelesBoitesOptions,
                            searchable: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, {
                            "no-results-text": "Aucun modèle trouvé",
                            placeholder: "Sélectionner le modèle de la boîte"
                          }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "modeleBoite",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  (!$setup.etatAgence)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                            _createTextVNode(" Agence "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _createVNode(_component_Field, {
                            name: "bureau",
                            modelValue: $setup.bureau,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.bureau) = $event))
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_Multiselect, _mergeProps({
                                options: $setup.bureausBoitesOptions,
                                searchable: true,
                                modelValue: field.value,
                                "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                              }, field, {
                                placeholder: "Sélectionner une agence",
                                "no-results-text": "Aucune agence trouvée"
                              }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "bureau",
                            class: "text-danger"
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Abonné "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "abonne",
                        modelValue: $setup.abonne,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.abonne) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, {
                            placeholder: "Rechercher un abonné",
                            "filter-results": false,
                            "min-chars": 3,
                            "resolve-on-load": false,
                            delay: 0,
                            searchable: true,
                            "options-limit": 300,
                            "no-results-text": "Aucun abonné trouvé",
                            options: async (query) => {
                          return await $setup.fetchAbonnes(query)
                        },
                            noResultText: "Aucun enregistrement trouvé",
                            noOptionsText: "Tapez au moins trois caractères"
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "abonne",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Etat d'abonnement "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "option",
                        modelValue: $setup.etat,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.etat) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: $setup.etatsOptions,
                            searchable: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, {
                            placeholder: "Sélectionner un état",
                            "no-results-text": "Aucun état trouvé"
                          }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "option",
                        class: "text-danger"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("button", {
                        class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-lg-0",
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.printTable && $setup.printTable(...args)))
                      }, [...(_cache[10] || (_cache[10] = [
                        _createTextVNode(" Exporter ", -1),
                        _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1)
                      ]))])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("table", _hoisted_22, [
              _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " REFERENCE "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " DATE ABONNEMENT "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, "Abonné"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, "Loyer"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, "Dernière paie"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, "Total"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, "Impayés"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, "Boite"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, "Agence"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, "Statut")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.abonnements, (abon, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_23, _toDisplayString(abon.a_refAbo), 1),
                    _createElementVNode("td", _hoisted_24, _toDisplayString($setup.format_Date(abon.a_createdAt)), 1),
                    _createElementVNode("td", _hoisted_25, _toDisplayString(abon.abon_nomComplet), 1),
                    _createElementVNode("td", _hoisted_26, _toDisplayString(abon.a_loyer ? $setup.separateur(abon.a_loyer) : 0), 1),
                    _createElementVNode("td", _hoisted_27, _toDisplayString($setup.format_Date(abon.r_updatedAt)), 1),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(abon.paiements ? $setup.separateur(abon.paiements) : 0), 1),
                    _createElementVNode("td", _hoisted_29, _toDisplayString($setup.separateur((abon.totalDu - abon.paiements) < 0 ? - (abon.totalDu - abon.paiements) :
                      (abon.totalDu - abon.paiements))), 1),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(abon.boi_refBoite), 1),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(abon.a_estMPostBox == 1 ? abon.agence_nom : abon.bu_nom), 1),
                    _createElementVNode("td", _hoisted_32, [
                      (abon.a_etat == 'En attente')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, "En attente"))
                        : _createCommentVNode("", true),
                      (abon.a_etat == 'Actif')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Actif"))
                        : _createCommentVNode("", true),
                      (abon.a_etat == 'Résilié')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Résilié"))
                        : _createCommentVNode("", true),
                      (abon.a_etat == 'Inactif')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Inactif"))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_PaginationComponent, {
              page: $setup.page,
              totalPages: $setup.totalPages,
              totalElements: $setup.totalElements,
              limit: $setup.limit,
              onPaginate: $setup.handlePaginate
            }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
          ])
        ])
      ])
    ])
  ]))
}